// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.BlankDashboardTile.js" company="Izenda">  Copyright
// (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

import connect from 'share/enhancers/Izenda.Connect';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { propTypes as ObservablePropTypes } from 'mobx-react';
import DashboardConstants from 'logic/data/Izenda.DashboardConstants';
import ReportPartSelectionPopup from 'share/components/controls/ReportPartSelectionPopup/Izenda.ReportPartSelectionPopup';
import ReportPartSelectionConstants from 'logic/data/Izenda.ReportPartSelectionConstants';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import { values, clone } from 'lodash/fp';

@connect()
export default class BlankDashboardTile extends Component {
  static propTypes = {
    dashboardPart: ObservablePropTypes.observableObject.isRequired,
    dashboardDetail: ObservablePropTypes.observableObject.isRequired,
    store: ObservablePropTypes.observableObject.isRequired,
    viewMode: PropTypes.bool
  };

  publishFinishedRender() {
    const props = this.props;
    // This is intended to alert the component has finished rendering.
    // Printing is listening on this.
    props.finishedRender && props.finishedRender();
  }

  componentDidMount() {
    this.publishFinishedRender();
  }

  componentDidUpdate() {
    this.publishFinishedRender();
  }

  onClickIcon = (item: any): void => {
    const { props, props: { store, loader, dashboardPart, dashboardDetail, viewMode } } = this;

    if (viewMode) {
      return;
    } else if (item.needPopup) {
      props.openPopup(ReportPartSelectionPopup, {
        onChange(result) {
          const dashboardPartType = clone(item);
          const report = result.report;
          const reportPart = result.reportPart;

          loader.startLoading();
          store
            .setDashboardTileType(dashboardPart, dashboardPartType, reportPart, report)
            .finally(loader.endLoading.bind(loader));
        },
        type: ReportPartSelectionConstants.TYPE.REPORT_PART
      });
    } else {
      dashboardDetail.setType(dashboardPart, clone(item));
    }
  };

  render() {
    const { props: { localization, disabled } } = this;

    const listButtons = values(DashboardConstants.TILE_TYPE).map(item => (
      <button
        disabled={disabled}
        className="btn btn-default izenda-BlankDashboardTile-TileType-btn"
        key={item.type}
        title={item.label}
        onClick={this.onClickIcon.bind(this, item)}
      >
        <span className={item.icon} />
        {item.label}
      </button>
    ));

    return (
      <GridLayout className="izenda-BlankDashboardTile u_overflowHidden u_fullSize">
        <GridLayout.Row className="izenda-BlankDashboardTile-TileType u_flex u_fullHeight u_noMarginAll u_alignItemCenter">
          <GridLayout.Col cols={6} className="u_textRight u_textUppercase u_paddingTop">
            <p>{localization.getText('DASHBOARD_MESSAGE_CREATE_DASHBOARD_TILE')}</p>
            <p>{localization.getText('DASHBOARD_LABEL_SELECT_A_TYPE')}</p>
          </GridLayout.Col>
          <GridLayout.Col cols={6}>
            <div className="btn-group-vertical">{listButtons}</div>
          </GridLayout.Col>
        </GridLayout.Row>
      </GridLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardGrid/DashboardTile/BlankTile/Izenda.BlankDashboardTile.js